module.exports = __webpack_public_path__ + "img/sourceFile.4e5b7cad.png";